var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3695_9682",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.8393C0 18.1834 3.70517 22.8036 10.5196 22.8036C13.8848 22.8036 16.8013 21.3286 17.7811 19.0193H17.9731L18.5475 22.4141H22.9341V11.2282H12.2874V14.8461H16.4845V15.0389C16.4845 16.1796 15.143 17.4594 12.3538 17.4594C9.77407 17.4618 7.68551 16.21 7.68551 11.8393C7.68551 7.94374 9.66608 6.5519 12.1786 6.5519C14.3295 6.5519 16.4589 7.35901 16.5653 10.2531L22.7238 8.19492C22.3406 3.88261 18.3371 0.849365 12.0762 0.849365C4.26191 0.849365 0.00239962 5.30165 0.00239962 11.8409",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3695_9682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9341 0.849365H0V22.8044H22.9341V0.849365Z",
    fill: "url(#paint0_linear_3695_9682)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3695_9682",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 0,
    width: 26,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.523 11.9823C30.523 8.30834 32.1845 6.69493 34.9953 6.69493C37.8062 6.69493 39.4668 8.30834 39.4668 11.9823C39.4668 15.5715 37.8062 17.2417 34.9953 17.2417C32.1845 17.2417 30.523 15.5715 30.523 11.9823ZM22.8359 11.9823C22.8359 18.7999 26.8611 22.9459 34.9945 22.9459C43.128 22.9459 47.1323 18.7983 47.1323 11.9823C47.1323 5.16631 43.1328 0.98999 34.9953 0.98999C26.8579 0.98999 22.8367 5.16391 22.8367 11.9823",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3695_9682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1323 0.98999H22.8359V22.9459H47.1323V0.98999Z",
    fill: "url(#paint1_linear_3695_9682)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3695_9682",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 21,
    width: 25,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82854 32.9824C7.82854 29.3092 9.48914 27.6958 12.3008 27.6958C15.1125 27.6958 16.7723 29.3092 16.7723 32.9824C16.7723 36.5724 15.1109 38.2418 12.3008 38.2418C9.49074 38.2418 7.82854 36.5724 7.82854 32.9824ZM0.140625 32.9824C0.140625 39.8008 4.16576 43.9467 12.2992 43.9467C20.4327 43.9467 24.4362 39.8008 24.4362 32.9824C24.4362 26.164 20.4367 21.9908 12.2992 21.9908C4.16176 21.9908 0.140625 26.1648 0.140625 32.9824Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3695_9682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4378 21.9908H0.140625V43.9467H24.4378V21.9908Z",
    fill: "url(#paint2_linear_3695_9682)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3695_9682",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 22,
    width: 24,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4817 28.1403H35.826C38.1681 28.1403 39.7455 28.7523 39.7455 32.9822C39.7455 37.2121 38.2121 37.824 35.826 37.824H31.4817V28.1403ZM24.2441 22.4082V43.557H36.5283C43.1931 43.557 47.3679 39.9942 47.3679 32.9822C47.3679 25.9702 43.1931 22.4082 36.5283 22.4082H24.2441Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3695_9682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3673 22.408H24.2412V43.5567H47.3673V22.408Z",
    fill: "url(#paint3_linear_3695_9682)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3695_9682",
    x1: 11.6377,
    y1: 22.5119,
    x2: 11.6377,
    y2: 0.55036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#52B962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#60BD5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#76C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#96CD48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BFD938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3695_9682",
    x1: 35.1815,
    y1: 22.6627,
    x2: 35.1815,
    y2: 0.701144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#52B962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#60BD5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#76C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#96CD48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BFD938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3695_9682",
    x1: 12.109,
    y1: 22.2675,
    x2: 12.109,
    y2: 44.1876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5EAC67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#988372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C26579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DC537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E64C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EC417F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3695_9682",
    x1: 35.4743,
    y1: 22.943,
    x2: 35.4743,
    y2: 44.0563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5EAC67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#988372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C26579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DC537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E64C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EC417F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3E7F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon);
export default __webpack_public_path__ + "static/media/headerIcon.7b40b388947a908121dc681f9e49e91f.svg";
export { ForwardRef as ReactComponent };